import { call, put } from 'redux-saga/effects';

import { Messages } from '../../../../codegen/Localize';
import { IExtractTaskInfo } from '../../../../ts/models/IExtractTaskInfo';
import { Set } from '../../../../ts/models/Set';
import { DeleteExtractTasksAction } from '../../../../ts/services/DeleteExtractTasksAction';
import { requestFailed } from '../../../actions/RequestFailedAction';
import { DeleteExtractRefreshAction } from '../../../actions/spaces/DeleteExtractRefreshAction';
import { requestSpaceContents } from '../../../actions/spaces/RequestSpaceContentsActions';
import { ServiceLocator } from '../../../ServiceLocator';

export function* handleDeleteExtractRefreshAction(action: DeleteExtractRefreshAction) {
  try {
    yield call(executeDeleteExtractRefreshAction, action.tasks);
    yield put(requestSpaceContents());
  } catch (e) {
    yield put(requestFailed(e, Messages.unexpectedError()));
  }
}

export function executeDeleteExtractRefreshAction(items: IExtractTaskInfo[]) {
  const deleteExtractRefreshService = ServiceLocator.get<DeleteExtractTasksAction>('DeleteExtractTasksAction');
  const context = ServiceLocator.getAngularActionContext();
  return deleteExtractRefreshService.executeWithContext(Set.fromIdItemArray(items), context);
}
